import { useState, useEffect } from "react";
import {
  Container,
  Text,
  Grid,
  Badge,
  Center,
  Loader,
  Button,
  Stack,
} from "@mantine/core";
import { deletePrompt, getSinglePrompt } from "../../api";
import PromptText from "../PromptText";
import { Link, useLocation } from "wouter";
import { useStore } from "../../store";
import { IconArrowRight, IconPencil, IconTrash } from "@tabler/icons-react";
import { modals } from "@mantine/modals";

export default function PromptDetails({ params }) {
  const [prompt, setPrompt] = useState(null);
  const [, setLocation] = useLocation();
  // const activeTemplate = useStore((state) => state.activeTemplate);
  const setActiveTemplate = useStore((state) => state.setActiveTemplate);

  useEffect(() => {
    getSinglePrompt(params.id).then((data) => {
      setPrompt(data);
    });
  }, [params.id]);

  if (!prompt)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  const openDeleteModal = (prompt) =>
    modals.openConfirmModal({
      title: `Delete prompt '${prompt.title}'`,
      centered: true,
      children: (
        <Text size="sm">
          Are you sure you want to delete this prompt? This action cannot be
          undone.
        </Text>
      ),
      labels: { confirm: "Delete prompt", cancel: "Cancel" },
      confirmProps: { color: "red" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => {
        deletePrompt(params.id).then(() => {
          setLocation("/prompts");
        });
      },
    });

  return (
    <Container px={0}>
      <Grid justify="space-between">
        <Grid.Col span={12}>
          <Text mb="sm" fw={500}>
            {prompt.title}
          </Text>
        </Grid.Col>
        {/* <Grid.Col span={3}>
          <Text mb="sm" fw={500}>
            Versions
          </Text>
          <Paper p="xs" mb="xs">
            <Group>
              <UserAvatar profile={{firstName: "John", lastName: "Doe"}} /> John Doe
            </Group>
            <Text ta="right" c="dimmed">
              <ReactTimeago date={prompt.created} />
            </Text>
          </Paper>
        </Grid.Col> */}

        <Grid.Col span={10}>
          <PromptText text={prompt.promptText} />

          {prompt.defaultModel && <Badge>{prompt.defaultModel}</Badge>}
          {/* <Code block>{JSON.stringify(prompt, null, 2)}</Code> */}
        </Grid.Col>

        <Grid.Col span={2}>
          <Stack>
            <Text fw={500}>Actions</Text>
            <Button
              component={Link}
              to={`/prompts/edit/${params.id}`}
              rightSection={<IconPencil />}
            >
              Edit
            </Button>

            <Button
              onClick={() => {
                setActiveTemplate(prompt.promptText);
                setLocation("/bulk?fromTemplate");
              }}
              rightSection={<IconArrowRight />}
            >
              Run
            </Button>
            <Text mt="md" fw={500}>
              Versions
            </Text>
            <Badge variant="outline">Coming Soon!</Badge>

            <Button
              mt="xl"
              rightSection={<IconTrash />}
              onClick={() => {
                openDeleteModal(prompt);
              }}
              color="red"
              variant="outline"
            >
              Delete
            </Button>
          </Stack>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
